// Dynamic labels based on business_type
// Supported types: gym, condominium, hotel, pool

const LABELS = {
  gym: {
    businessName: 'Gimnasio',
    businessNamePlural: 'Gimnasios',
    member: 'Socio',
    members: 'Socios',
    membership: 'Membresia',
    memberships: 'Membresias',
    plan: 'Plan',
    plans: 'Planes',
    class: 'Clase',
    classes: 'Clases',
    trainer: 'Entrenador',
    trainers: 'Entrenadores',
    attendance: 'Asistencia',
    schedule: 'Horario',
    schedules: 'Horarios',
    access: 'Acceso',
    accesses: 'Accesos',
    entry: 'Entrada',
    exit: 'Salida',
    guest: 'Invitado',
    guests: 'Invitados',
    routine: 'Rutina',
    routines: 'Rutinas',
    gamification: 'Gamificacion',
    pos: 'TPV/POS',
    createBusiness: 'Crear Gimnasio',
    newBusiness: 'Nuevo Gimnasio',
    businessIcon: 'Building2',
    welcomeMessage: 'Bienvenido a {name}',
    memberCode: 'Codigo de socio',
    renewMembership: 'Renueva tu membresia',
    expiredMembership: 'Tu membresia ha vencido',
    activeMembership: 'Membresia activa',
    maxMembers: 'Capacidad maxima de socios',
    memberCapacity: 'Capacidad de socios',
  },
  condominium: {
    businessName: 'Condominio',
    businessNamePlural: 'Condominios',
    member: 'Residente',
    members: 'Residentes',
    membership: 'Cuota',
    memberships: 'Cuotas',
    plan: 'Cuota',
    plans: 'Cuotas',
    class: 'Amenidad',
    classes: 'Amenidades',
    trainer: 'Conserje',
    trainers: 'Conserjes',
    attendance: 'Registro',
    schedule: 'Horario',
    schedules: 'Horarios',
    access: 'Acceso',
    accesses: 'Accesos',
    entry: 'Entrada',
    exit: 'Salida',
    guest: 'Visita',
    guests: 'Visitas',
    routine: 'Servicio',
    routines: 'Servicios',
    gamification: 'Programa de Puntos',
    pos: 'Cobros',
    createBusiness: 'Crear Condominio',
    newBusiness: 'Nuevo Condominio',
    businessIcon: 'Building',
    welcomeMessage: 'Bienvenido a {name}',
    memberCode: 'Codigo de residente',
    renewMembership: 'Renueva tu cuota',
    expiredMembership: 'Tu cuota ha vencido',
    activeMembership: 'Cuota al dia',
    maxMembers: 'Capacidad maxima de residentes',
    memberCapacity: 'Capacidad de residentes',
  },
  hotel: {
    businessName: 'Hotel',
    businessNamePlural: 'Hoteles',
    member: 'Huesped',
    members: 'Huespedes',
    membership: 'Reserva',
    memberships: 'Reservas',
    plan: 'Tarifa',
    plans: 'Tarifas',
    class: 'Servicio',
    classes: 'Servicios',
    trainer: 'Recepcionista',
    trainers: 'Recepcionistas',
    attendance: 'Check-in',
    schedule: 'Horario',
    schedules: 'Horarios',
    access: 'Acceso',
    accesses: 'Accesos',
    entry: 'Check-in',
    exit: 'Check-out',
    guest: 'Visitante',
    guests: 'Visitantes',
    routine: 'Servicio',
    routines: 'Servicios',
    gamification: 'Programa Fidelidad',
    pos: 'Consumos',
    createBusiness: 'Crear Hotel',
    newBusiness: 'Nuevo Hotel',
    businessIcon: 'Hotel',
    welcomeMessage: 'Bienvenido a {name}',
    memberCode: 'Codigo de huesped',
    renewMembership: 'Renueva tu reserva',
    expiredMembership: 'Tu reserva ha expirado',
    activeMembership: 'Reserva activa',
    maxMembers: 'Capacidad maxima de huespedes',
    memberCapacity: 'Capacidad de huespedes',
  },
  pool: {
    businessName: 'Piscina',
    businessNamePlural: 'Piscinas',
    member: 'Usuario',
    members: 'Usuarios',
    membership: 'Abono',
    memberships: 'Abonos',
    plan: 'Tarifa',
    plans: 'Tarifas',
    class: 'Actividad',
    classes: 'Actividades',
    trainer: 'Socorrista',
    trainers: 'Socorristas',
    attendance: 'Registro',
    schedule: 'Horario',
    schedules: 'Horarios',
    access: 'Acceso',
    accesses: 'Accesos',
    entry: 'Entrada',
    exit: 'Salida',
    guest: 'Visitante',
    guests: 'Visitantes',
    routine: 'Actividad',
    routines: 'Actividades',
    gamification: 'Programa de Puntos',
    pos: 'Taquilla',
    createBusiness: 'Crear Piscina',
    newBusiness: 'Nueva Piscina',
    businessIcon: 'Waves',
    welcomeMessage: 'Bienvenido a {name}',
    memberCode: 'Codigo de usuario',
    renewMembership: 'Renueva tu abono',
    expiredMembership: 'Tu abono ha vencido',
    activeMembership: 'Abono activo',
    maxMembers: 'Aforo maximo',
    memberCapacity: 'Aforo',
  }
};

export const BUSINESS_TYPES = [
  { value: 'gym', label: 'Gimnasio', icon: 'Dumbbell' },
  { value: 'pool', label: 'Piscina', icon: 'Waves' },
  { value: 'condominium', label: 'Condominio', icon: 'Building' },
  { value: 'hotel', label: 'Hotel', icon: 'Hotel' },
];

export function getLabels(businessType) {
  return LABELS[businessType] || LABELS.gym;
}

export default getLabels;
